<template>
    <v-menu absolute nudge-bottom="20" nudge-left="230" close-on-click>
        <template v-slot:activator="{ on: menu, attrs }">
            <v-btn plain icon v-bind="attrs" v-on="{ ...menu }" @click="getList()">
                <v-icon large>mdi-folder-home</v-icon>
            </v-btn>
        </template>    
        <div v-if="!loading">
            <v-list dense v-if="acco_list.length>0" max-height="500" two-line>
                <!--
                <div v-if="acco_list.length>0&&acco_list[0].encrid!==''" class="title-div" style="width: 100%; cursor: pointer;">
                    <v-icon color="red" class="ml-4">mdi-close</v-icon>
                    <div style="font-weight: 600;">Clear list</div>
                </div>
                -->
                <v-list-item v-for="acco in acco_list" :key="acco.huiscode" @click="openAcco(acco)" class="list-item">
                    <div class="outer-div">
                        <div class="inner-div">
                            <div>
                                <div class="title-div">
                                    <div class="acco-code">{{ acco.huiscode }}</div>
                                </div>
                                <div class="title-div" v-if="acco.max_pers!==0">
                                    <v-icon>mdi-account-multiple</v-icon>
                                    <div class="max-pers">{{ acco.max_pers }}</div>
                                    <div v-if="acco.onPark" class="on-park">Prk.</div>
                                </div>
                                <div class="timestamp">{{ acco.visited }}</div>
                                <div class="timestamp">{{ acco.visited_time }}</div>
                            </div>
                            <div class="circle-container">
                                <div class="circle-div stat" v-if="acco.huisstat!==''">{{ acco.huisstat }}</div>
                                <div class="circle-div err" v-if="acco.huiserr!==0">{{ acco.huiserr }}</div>
                                <div class="circle-div wrn" v-if="acco.huiswrn!==0">{{ acco.huiswrn }}</div>
                            </div>
                            <div class="pic">
                                <v-img :src="acco.foto" width="100px" height="75px"></v-img>
                            </div>
                        </div>
                    </div>                
                </v-list-item>
            </v-list>        
        </div>
    </v-menu>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                acco_list: []
            }
        },
        methods: {      
            openAcco(acco){
                if(acco.encrid!=='')this.$router.open('/huis/onHuis/' + acco.encrid)
            },   
            getList() {
                this.loading=true
                this.$axios
                    .post("ares/json/ares/huis/getRecentAccoList.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getAccoList"
                        }
                    })
                    .then(res => {
                        this.loading=false
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.acco_list = res.data.AccoList;
                        }
                    });  
            },
        }
    }
</script>
<style scoped>
.outer-div{
    padding: 3px 0px 3px 3px;
    background-color: white;
}
.inner-div{
    display:flex;
    flex-direction: row;
    align-items: top;
    border-top: 1px solid;
    border-color: lightgray;
    background-color: white; 
}
.pic{
    margin-top: 0;
    padding-top: 0;
    margin-left: auto;
    border-color: lightgray;
}
.list-item{
    background-color: white;
}
.max-pers{
    margin-left: 5px;
}
.on-park{
    margin-left: auto; 
    margin-right: 8px;
}
.title-div{
    font-size: 12px; 
    display: flex; 
    flex-direction: row; 
    align-items: center; 
    width: 80px
}
.acco-code{
    font-size: 12px; 
    margin-top: 3px; 
    font-weight: 800;
}
.circle-container{
    display: flex; 
    flex-direction: column; 
    margin-left: auto; 
    padding-right: 2px;
}
.circle-div{
    margin-top: 3px; 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 1px solid;
    border-radius: 50%;    
    font-weight: 600;
    width: 21px;
    height: 21px;    
    font-weight: 600;
    margin-left: auto;
    margin-right: 4px;
    font-size: small;
}
.err{    
    border-color: red;
    color: red;
}
.wrn {
    border-color: orange;
    color: orange;
}
.stat{
    border-color: grey;
    color: grey;
}
.timestamp{
    font-size: x-small;
}
</style>